<script>
import Icon from '../icon';

export default {
  components: {
    Icon
  },

  computed: {
    searching () { return this.$store.state.databaseSearch.searching },
    recordType: {
      get () {
        return this.$store.state.databaseSearch.recordType;
      },
      set (value) {
        this.$store.commit('databaseSearch/setRecordType', value);
      }
    },
    query: {
      get () {
        return this.$store.state.databaseSearch.query;
      },
      set (value) {
        this.$store.commit('databaseSearch/setQuery', value);
      }
    }
  },

  mounted () {
    const self = this;
    self.query = self.$route.query.query || "";
    self.recordType = self.$route.query.recordType || "";
  },
}
</script>

<template lang="html">
  <div class="DatabaseSearch-primary u-mt2 u-mb2">

    <div class="DatabaseSearch-primary-left">
      <label for="database-recordType">Record Types</label>
      <div class="js-custom-select">
        <select id="database-recordType" v-model="recordType">
          <option value="">All Types</option>
          <option value="Person">People</option>
          <option value="District">Districts</option>
        </select>
        <icon icon="arrow-down"></icon>
      </div>
    </div>

    <div class="DatabaseSearch-primary-right">
      <label for="database-query">Keyword</label>
      <div class="DatabaseSearch-query">
        <input type="text" id="database-query" placeholder="Enter a keyword or a ZIP code" autocomplete="off" v-model.trim="query">
        <div class="Button Button--square DatabaseSearch-submit" type="submit">
          <span class="u-screenreader">Search</span>
          <div v-if="searching" class="DatabaseSearch-submit-spinner"></div>
          <icon v-if="!searching" icon="search"></icon>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// primary-facets.vue?e9d3f3d8